import CryptoJS from "crypto-js/core";
const AES = require("crypto-js/aes")

export const decrypt = (encryptedText: string, key: string) => {
    const parsedEncryptedText = CryptoJS.enc.Base64.parse(encryptedText);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);

    const aes = CryptoJS.algo.AES.createDecryptor(parsedKey, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: parsedKey
    });
    const decrypted = aes.finalize(parsedEncryptedText);

    return CryptoJS.enc.Utf8.stringify(decrypted);
}